<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                class="realtime_echo"
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :custom_header="true"
                :show_table_border="true"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <span>
                        說明：<br>
                        1.警示條件：表示待命區範圍內的雷達回波大於及等於30dBZ且占待命區面積達60%以上。<br>
                        紅燈: <span class="description-dot" style="background: #FF0000"/>：達警示標準<br>
                        綠燈: <span class="description-dot" style="background: #00FF00"/>：未達警示標準<br>   
                        --: 無資料<br>
                        2.即時回波警示：使用即時觀測的雷達整合回波，以上述警示條件進行警示。 <br>
                        3.預報回波警示 ：使用最近3報且預報相同目標時間的模式回波，以上述警示條件進行警示。 <br>
                    </span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js";
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { alert_color_style_mapping } from "@/config/monitor_config.js"
    import cloneDeep from 'lodash/cloneDeep'
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "./../qpe_datatable.vue";

	export default {
        name: 'realtime_echo',

        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable,
        },

        mixins: [monitor_mixin],
      
		data() {
			return {
                header: [],
                immutable_table_data: [],
                table_data: [],
                default_value: 238,
                error_text: '',

                should_show_raw_html_header: ['即時回波警示'],
            }
        },

        computed: {
            table_title() {
                return '回波警示表精簡版資訊'
            }
        },
    
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                let temp_table_data
                [temp_table_data, this.header] = this.reconstruct_table_data({...data}, [...header])
                this.table_data = this.reconstruct_alert_content(temp_table_data);
            },

            reconstruct_table_data(data, origin_header) {
                const table_data = [];
                const standby_area_list = Object.keys(data['QPESUMS'])
                let return_header = origin_header;

                Object.keys(data).forEach(first_header => {
                    if (first_header === 'QPESUMS') {
                        Object.keys(data[first_header]).forEach(standby_area_key => {
                            if(standby_area_list.includes(standby_area_key)) {
                                if (table_data.length < standby_area_list.length) {
                                    table_data.push({
                                        '待命區': standby_area_key,
                                        '即時回波警示': data[first_header][standby_area_key]
                                    })
                                }else {
                                    const row_index = table_data.findIndex(row_data =>  row_data['待命區'] ===  standby_area_key)
                                    table_data[row_index]['即時回波警示'] = data[first_header][standby_area_key]
                                }
                            }
                        })
                    }else {
                        // 排序資料以對應 前2、前1、最新
                        data[first_header].sort((a,b) => {
                            return a.initime - b.initime
                        }).forEach((datum, index) => {
                            const second_header = index
                            return_header = this.concat_return_header(return_header, first_header , second_header)

                            Object.keys(datum).forEach(standby_area_key => {
                                if(standby_area_list.includes(standby_area_key)) {
                                    if (table_data.length < standby_area_list.length) {
                                        const row_data = {
                                            '待命區': standby_area_key,
                                        }
                                        row_data[`${first_header}_${second_header}`] = datum[standby_area_key]
                                        table_data.push(row_data)
                                    }else {
                                        const row_index = table_data.findIndex(row_data =>  row_data['待命區'] ===  standby_area_key)
                                        table_data[row_index][`${first_header}_${second_header}`] = datum[standby_area_key]
                                    }
                                }
                            }) 
                        })
                    }
                })

                return [table_data, return_header]
            },

            reconstruct_alert_content(data_array) {
                return cloneDeep(data_array).map(datum => {
                    const be_concat_object = this.should_show_raw_html_header.reduce((accum, html_header) => {
                        const color = alert_color_style_mapping[datum[html_header]]
                        if(color) {
                            return { 
                                ...accum, 
                                ...{
                                    [html_header]: [{
                                        html: `<span class="dot" style="background: ${color}"/>`,
                                        center: true,
                                    }]
                                }
                            }
                        }       
                        return { 
                            ...accum, 
                            ...{
                                [html_header]: [{
                                    html: `<span> -- </span>`,
                                    center: true,
                                }]
                            }
                        }
                    }, {})
                    return {...datum, ...be_concat_object}
                }) 
            },

            concat_return_header(return_header, first_header, second_header) {
                if (second_header !== 2) {
                    return return_header
                }

                const header_value = `${first_header}_${second_header}`
                this.should_show_raw_html_header.push(header_value)
                if(return_header.length === 4) {
                    return_header = return_header.concat({
                        order: return_header.length,
                        value: header_value,
                        text: '預報回波警示(預報時間)',
                        second_text: `${first_header.substring(2, 4)}月${first_header.substring(4, 6)}日${first_header.substring(6, 8)}z`,
                        third_text: '最新'
                    })
                }
                else {
                    return_header = return_header.concat({
                        order: return_header.length,
                        value: header_value,
                        second_text: `${first_header.substring(2, 4)}月${first_header.substring(4, 6)}日${first_header.substring(6, 8)}z`,
                        third_text: '最新'
                    })
                } 
                return return_header
            }
        },
	}
</script>

<style>
    .realtime_echo .option-description {
        margin-left: 10px;
        border: thin solid #CCFF00;
        padding: 5px 10px;
    }

    .realtime_echo .dot {
        display: inline-block;
        border-radius: 50%;
        /* background: #ff0000; */
        height: 1.5em;
        width: 1.5em;
    }

    .realtime_echo .custom-header {
        background: #3366a9;
        color: white;
    }


</style>